export default __webpack_public_path__ + "static/media/mediaPic.ec4f76c9.png";